// API Request
// ------------------------------
export type ListSegment = {
  usage: string;
  accountId: number;
  inputType: string;
};

export type CustomSegment = {
  id: number;
  name: string;
  description: string;
  uu: number;
  usage: string;
  inputType: string;
  coordinatedAccount: number[];
  usePreference: string[];
  condition: string;
  conditionJson: string;
  fileName: string;
  createdAt: string;
  createdBy: number;
  updatedAt: string;
  updatedBy: number;
  accountGroupId: number;
};

export type EstimateSegment = {
  condition: string;
};

export type UploadFile = {
  bucket: string;
  keyPrefix: string;
  region: string;
  file: string;
  fileName: string;
};

export type GetSegmentCondition = {
  updatedAt: string;
};

// API Response
// ------------------------------
export type ResListSegment = {
  id: number;
  name: string;
  status: string;
  uu: number;
  coordinatedAccount: string | number[];
  inputType: string;
  usage: string;
  usePreference: string | string[];
  fileName: string;
  accountGroupId: number;
  updatedAt: string;
  updatedBy: string;
};

export type ResGetSegment = {
  name: string;
  description: string;
  status: string;
  usage: string;
  inputType: string;
  coordinatedAccount: string | number[];
  usePreference: string | string[];
  uu: number;
  fileName: string;
  conditionJson: string;
  createdAt: string;
  createdBy: number;
  updatedAt: string;
  updatedBy: number;
  uploadedAt: string;
  version: number;
};

export type ResAvailableTarget = {
  id: number;
  name: string;
}

export const initResGetSegment: ResGetSegment = {
  name: "",
  description: "",
  status: "",
  usage: "",
  inputType: "",
  coordinatedAccount: "",
  usePreference: "",
  uu: 0,
  fileName: "",
  conditionJson: "",
  createdAt: "",
  createdBy: 0,
  updatedAt: "",
  updatedBy: 0,
  uploadedAt: "",
  version: 0,
};

// Other
// ------------------------------
export type AccountCoordinates = {
  id: Array<number>;
  name: string;
};

export const initAccountCoordinates: AccountCoordinates = {
  id: [],
  name: "",
};

// 選択条件
// ----------
export type EditJSON = {
  spMode: boolean;
  filter: Conditions;
  except: Conditions;
};

export type Conditions = {
  groupOperation: string;
  groupConditions: Array<GroupConditions>;
};

export type GroupConditions = {
  id: string;
  operation: string;
  itemConditions: Array<ItemConditions>;
};

export type ItemConditions = {
  id: string;
  category: string;
  subcategory: string;
  subSubcategory: string;
  field: string;
  value: any;
};
// ----------

export type Categories = {
  category: string,
  attributes: any,
  field: string,
};

export type Filter = {
  usage: string;
  accountId: number;
  status: string;
  isAffinity: boolean;
  inputType: string;
};

export type CoordinateAccount = {
  id: number;
  accounts: number[];
};

// Enum
// ------------------------------
export const Usage = {
  Temporary: "TEMPORARY",
  Production: "PRODUCTION",
} as const;
export type Usage = typeof Usage[keyof typeof Usage];

export const InputType = {
  Condition: "CONDITION",
  File: "FILE",
} as const;
export type InputType = typeof InputType[keyof typeof InputType];

export const UsePreference = {
  Target: "TARGET",
  Except: "EXCEPT",
} as const;
export type UsePreference = typeof UsePreference[keyof typeof UsePreference];

export const Operation = {
  And: "AND",
  Or: "OR",
} as const;
export type Operation = typeof Operation[keyof typeof Operation];

export const Status = {
  Available: "AVAILABLE",
  Processing: "PROCESSING",
  Unavailable: "UNAVAILABLE",
  Invalid: "INVALID",
  Validating: "VALIDATING",
} as const;
export type Status = typeof Status[keyof typeof Status];

export const FirstCategory = {
  Demographic: "demographic",
  DService: "dservice-subscribe",
  Docomo: "docomo-service-regist",
  DPoint: "dpoint",
  Ms: "ms-permission",
  App: "applog-install",
  Search: "search-query",
  LocFeature: "loc-feature",
  Questionnaire: "questionnaire",
  ProductPurchaseM3: "product-purchase",
  ForDpointDm: "for_dpoint_dm",
} as const;
export type FirstCategory = typeof FirstCategory[keyof typeof FirstCategory];

// cache key
// ------------------------------
export let POSEIDON_CONDITION = "poseidon_condition";
export let POSEIDON_CONDITION_UPDATEDAT = "poseidon_condition_updatedat";
